const validate = values => {
  let errors = {}

  return errors
}

export default validate
